import { UserCountryCode } from '@shared/types/countryCodes.ts';

export function formatCampaignCountryName(countryCode: UserCountryCode) {
  return `country.${countryCode.toLowerCase()}.name`;
}
